import { memo } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import type { MerchantsMethodsPivot } from "features/pivots/types";
import {
    PaymentMethodCountries,
    PaymentMethodCurrencies,
    PaymentMethodTag
} from "ui/molecules/PaymentMethod";
import PaymentMethodName from "./PaymentMethodName";
import RiskLevel from "./RiskLevel";
import PaymentMethodSwitch from "./PaymentMethodSwitch";
import LimitationsInfo from "./LimitationsInfo";
import PaymentMethodIsAssignable from "./PaymentMethodIsAssignable";

const MerchantPaymentMethodPSPSummary = (props: MerchantsMethodsPivot) => {
    const sharedSlotProps = {
        tooltip: {
            title: null
        },
        label: {
            sx: {
                display: 'flex',
                alignItems: 'center',
                gap: 1
            }
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                gap: 4,
                minHeight: 80
            }}
        >
            <PaymentMethodName
                {...props}
            />
            <Stack
                divider={(
                    <Divider
                        sx={{
                            my: 1
                        }}
                        orientation='horizontal'
                    />
                )}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        alignItems: 'center',
                        gap: 4,
                    }}
                >
                    <PaymentMethodTag
                        tag={props.paymentMethodTag}
                        slotProps={{
                            ...sharedSlotProps,
                            label: {
                                ...sharedSlotProps.label,
                                title: 'Tag: '
                            }
                        }}
                    />
                    <PaymentMethodCountries
                        forCountries={props.paymentMethodForCountries}
                        slotProps={{
                            ...sharedSlotProps,
                            label: {
                                ...sharedSlotProps.label,
                                title: 'Countries: '
                            }
                        }}
                    />
                    <PaymentMethodCurrencies
                        forCurrencies={props.paymentMethodForCurrencies}
                        slotProps={{
                            ...sharedSlotProps,
                            label: {
                                ...sharedSlotProps.label,
                                title: 'Currencies: '
                            }
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'auto auto 2fr 1fr',
                        alignItems: 'center',
                        gap: 4,
                    }}
                >
                    <PaymentMethodIsAssignable
                        {...props}
                    />
                    <RiskLevel
                        {...props}
                    />
                    <LimitationsInfo
                        {...props}
                    />
                    <PaymentMethodSwitch
                        {...props}
                    />
                </Box>
            </Stack>
        </Box>
    );
};

export default memo(MerchantPaymentMethodPSPSummary);
